import Highcharts from 'highcharts';

const HighchartsMore   = require('highcharts/highcharts-more');
const Exporting        = require('highcharts/modules/exporting');
const Accessibility    = require('highcharts/modules/accessibility');
const OfflineExporting = require('highcharts/modules/offline-exporting');
const ExportData       = require('highcharts/modules/export-data');
const Drilldown        = require('highcharts/modules/drilldown');

// Helper to handle default export vs direct function
const initModule = (mod: any) => {
  if (!mod) return;
  const fn = mod.default || mod;
  if (typeof fn === 'function') {
    fn(Highcharts);
  }
};

// Initialize modules safely
initModule(HighchartsMore);
initModule(Exporting);
initModule(Accessibility);
initModule(OfflineExporting);
initModule(ExportData);
initModule(Drilldown);

export default Highcharts;
